import { useReducer } from "react";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { DateTime } from "luxon";

const Application = props => {
  const { application } = props;
  const author = application._embedded.author?.[0];

  const [showMore, toggleShowMore] = useReducer(i => !i, false);

  return (
    <div className="oCandidates_application">
      <div className="header">
        <a className="name" href={`/designers/${author.slug}`}>
          {author.name}
        </a>
        <div className="createdAt">
          Sent on{" "}
          {DateTime.fromISO(application.date)
            .setLocale("en")
            .toLocaleString(DateTime.DATETIME_MED)}
        </div>
      </div>
      <div className="contact">{author.user_email}</div>
      <div
        className={`message ${showMore ? "open" : "close"}`}
        dangerouslySetInnerHTML={{ __html: application.excerpt?.rendered }}
      />
      <div className="showMore" onClick={toggleShowMore}>
        {showMore ? "Collapse" : "Read more"}
        <Icon path={showMore ? mdiChevronUp : mdiChevronDown} size="16px" />
      </div>
    </div>
  );
};

export default Application;
